import { getDateFormatted } from '@vindr/utils/helpers/common.helper';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';

const currentDate = dayjs();
interface FormDatePickerProps extends FormItemProps {
  showTime?: boolean;
  notAccept?: 'part' | 'feature';
}

const FormDatePicker = ({
  name,
  label,
  placeholder,
  rules,
  required,
  disabled,
  showTime,
  notAccept = 'part',
  className,
  noStyle,
  ...props
}: FormDatePickerProps): JSX.Element => {
  const { t } = useTranslation('Vindoc');
  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <Form.Item
      name={name}
      label={t(label)}
      rules={rulesMemo}
      getValueProps={(value) => ({
        value: value ? (showTime ? dayjs(value) : dayjs(value).startOf('day')) : null,
      })}
      getValueFromEvent={(value) =>
        value ? (showTime ? value.toISOString() : value.startOf('day').toISOString()) : null
      }
      className={className}
      noStyle={noStyle}
    >
      <DatePicker
        disabledDate={(current) => {
          if (!notAccept) return false;

          if (notAccept === 'feature') {
            return current && dayjs(current).isAfter(currentDate);
          }

          if (notAccept === 'part') {
            return current && dayjs(current).isBefore(currentDate);
          }

          return false;
        }}
        placeholder={t(placeholder)}
        format={getDateFormatted(showTime)}
        className="w-full"
        disabled={disabled}
        showTime={showTime}
        {...props}
      />
    </Form.Item>
  );
};

export default FormDatePicker;
